import { CREATE, GET_LIST } from 'react-admin';
import * as constants from '../../constants/index';
import {
    FLIGHT_REQUEST_LIST,
    GetFlightRequestsListQuery,
    CHANGE_HIDDEN_COLUMNS,
    CHANGE_SELECTED_REQUESTS,
    REMOVE_FLIGHT_REQUESTS,
    CHANGE_SELECTED_FILTERS,
    CHANGE_COLUMNS_ORDER,
    FLIGHT_STATUS
} from './types';
import { ChipDataState } from '../table/types';

export const getAllFlightRequests = (groupName: string, getFlightRequestsListQuery: GetFlightRequestsListQuery) => ({
    type: FLIGHT_REQUEST_LIST,
    payload: { data: { groupNames: [groupName], query: getFlightRequestsListQuery } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.GET_FLIGHT_REQUESTS_LIST}`,
    },
});

export const changeHiddenColumns = (hiddenColumns: Array<any>, id: string) => ({
    type: CHANGE_HIDDEN_COLUMNS,
    payload: { data: hiddenColumns, id },
    requestPayload: { id }
});

export const changeColumnsOrder = (columnsOrder: Array<any>, id: string) => ({
    type: CHANGE_COLUMNS_ORDER,
    payload: { data: columnsOrder, id },
    requestPayload: { id }
});

export const changeSelectedFilters = (selectedFilters: ChipDataState, id: string) => ({
    type: CHANGE_SELECTED_FILTERS,
    payload: { data: selectedFilters, id },
    requestPayload: { id }
});

export const changeSelectedRequests = (selectedRequests: Array<any>, id: string) => ({
    type: CHANGE_SELECTED_REQUESTS,
    payload: { data: selectedRequests, id },
    requestPayload: { id }
});

export const removeFlightRequests = (ids: Array<string>) => ({
    type: REMOVE_FLIGHT_REQUESTS,
    payload: { data: { ids } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.REMOVE_FLIGHT_REQUESTS}`,
    },
});

export const getFlightRequestStatusList = () => ({
    type: FLIGHT_STATUS,
    meta: {
        fetch: GET_LIST,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.TRANSLATION.STATUS_TRANSLATION}`,
    },
});